// extracted by mini-css-extract-plugin
export default {"container":"Todo_container__SokCV"};